(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["joffz-cart-paper-v34"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.__joffzPaperCartV34) return;
  window.__joffzPaperCartV34 = true;

  let observer = null;
  let frame = 0;

  const getLabels = () => document.querySelector('[data-joffz-paper-cart-labels]');

  const setText = (node, value) => {
    if (node && value && node.textContent.trim() !== value) node.textContent = value;
  };

  const apply = () => {
    const drawer = document.querySelector('cart-drawer.joffz-cart-minimal');
    const labels = getLabels();
    if (!drawer || !labels) return;

    const heading = drawer.querySelector('.drawer__heading');
    if (heading) {
      const count = heading.querySelector('.drawer__heading-count');
      const rawCount = count?.textContent.match(/\d+/)?.[0] || '0';
      const textNode = [...heading.childNodes].find((node) => node.nodeType === Node.TEXT_NODE);
      if (textNode) {
        const desired = `${labels.dataset.cartTitle || 'Your cart'} `;
        if (textNode.nodeValue !== desired) textNode.nodeValue = desired;
      }
      if (count && count.textContent !== rawCount) count.textContent = rawCount;
    }

    const empty = drawer.querySelector('.drawer__inner-empty');
    if (empty) {
      const title = empty.querySelector('.cart__empty-title');
      const helper = empty.querySelector('.cart__empty-text');
      const cta = empty.querySelector('.joffz-cart__empty-cta');
      setText(title, labels.dataset.emptyText);
      setText(helper, labels.dataset.emptyText);
      setText(cta, labels.dataset.emptyCta);

      let message = empty.querySelector('.joffz-cart-paper-empty-message');
      if (!message) {
        message = document.createElement('div');
        message.className = 'joffz-cart-paper-empty-message';
        message.setAttribute('aria-hidden', 'true');

        const lineOne = document.createElement('span');
        lineOne.className = 'joffz-cart-paper-empty-message__line';
        lineOne.textContent = labels.dataset.emptyLead || '';

        const lineTwo = document.createElement('span');
        lineTwo.className = 'joffz-cart-paper-empty-message__line';

        const emphasis = document.createElement('em');
        emphasis.textContent = labels.dataset.emptyEmphasis || '';
        lineTwo.appendChild(emphasis);
        lineTwo.appendChild(document.createTextNode(` ${labels.dataset.emptyTail || ''}`));

        message.append(lineOne, lineTwo);
        empty.insertBefore(message, title || empty.firstChild);
      }
    }
  };

  const schedule = () => {
    window.cancelAnimationFrame(frame);
    frame = window.requestAnimationFrame(apply);
  };

  const init = () => {
    const drawer = document.querySelector('cart-drawer.joffz-cart-minimal');
    if (!drawer) return;

    apply();

    if (observer) observer.disconnect();
    observer = new MutationObserver(schedule);
    observer.observe(drawer, { childList: true, subtree: true, characterData: true });
  };

  document.addEventListener('shopify:section:load', init);
  window.addEventListener('pageshow', init, { passive: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["joffz-header-paper-v34"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.__joffzPaperHeaderV34) return;
  window.__joffzPaperHeaderV34 = true;

  const desktop = window.matchMedia('(min-width: 1100px)');
  let anchor = null;
  let currentForm = null;

  const getLabels = () => document.querySelector('[data-joffz-paper-header-labels]');

  const closeDisclosure = (details) => {
    if (!details) return;
    details.removeAttribute('open');
    document.documentElement.classList.remove('joffz-paper-currency-open');
    document.body?.classList.remove('joffz-paper-currency-open');
  };

  const enhanceForm = (form) => {
    if (!form || form.dataset.joffzPaperCurrencyBound === 'true') return;
    form.dataset.joffzPaperCurrencyBound = 'true';

    const details = form.querySelector('[data-country-disclosure]');
    const head = form.querySelector('.joffz-country__popover-head');
    const labels = getLabels();

    if (head) {
      const title = head.querySelector('p');
      if (title && labels?.dataset.currencyTitle) title.textContent = labels.dataset.currencyTitle;

      const oldCounter = head.querySelector(':scope > span');
      if (oldCounter) oldCounter.remove();

      if (!head.querySelector('.joffz-country__modal-close')) {
        const close = document.createElement('button');
        close.type = 'button';
        close.className = 'joffz-country__modal-close';
        close.setAttribute('aria-label', labels?.dataset.closeLabel || 'Close');
        close.innerHTML = '<svg viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M4 4l12 12M16 4L4 16" stroke="currentColor" stroke-width="1.25" stroke-linecap="round"/></svg>';
        close.addEventListener('click', () => closeDisclosure(details));
        head.appendChild(close);
      }
    }

    details?.addEventListener('toggle', () => {
      const open = details.open && desktop.matches;
      document.documentElement.classList.toggle('joffz-paper-currency-open', open);
      document.body?.classList.toggle('joffz-paper-currency-open', open);
    });

    form.addEventListener('click', (event) => {
      const option = event.target.closest('[data-country-option]');
      if (!option || !form.contains(option)) return;

      event.preventDefault();
      const input = form.querySelector('[data-country-input]');
      const countryCode = option.dataset.countryCode;
      if (!input || !countryCode) return;

      input.value = countryCode;
      closeDisclosure(details);

      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else form.submit();
    });
  };

  const placeCurrency = () => {
    const form = currentForm || document.querySelector('.joffz-header form.joffz-country-form.joffz-desktop-only');
    const destination = document.querySelector('.section-announcement .joffz-announcement-slider');
    if (!form) return;

    currentForm = form;
    enhanceForm(form);

    if (!anchor && form.parentNode) {
      anchor = document.createComment('joffz-paper-currency-anchor');
      form.parentNode.insertBefore(anchor, form);
    }

    if (desktop.matches && destination) {
      if (form.parentNode !== destination) destination.appendChild(form);
    } else if (anchor?.parentNode) {
      closeDisclosure(form.querySelector('[data-country-disclosure]'));
      anchor.parentNode.insertBefore(form, anchor.nextSibling);
    }
  };

  const closeOnOutsideClick = (event) => {
    if (!desktop.matches) return;
    const details = document.querySelector('.section-announcement .joffz-country[open]');
    if (!details || details.contains(event.target)) return;
    event.preventDefault();
    closeDisclosure(details);
  };

  const closeOnEscape = (event) => {
    if (event.key !== 'Escape') return;
    const details = document.querySelector('.section-announcement .joffz-country[open]');
    if (!details) return;
    closeDisclosure(details);
    details.querySelector('summary')?.focus({ preventScroll: true });
  };

  const init = () => {
    placeCurrency();
    window.setTimeout(placeCurrency, 80);
    window.setTimeout(placeCurrency, 350);
  };

  document.addEventListener('click', closeOnOutsideClick);
  document.addEventListener('keydown', closeOnEscape);
  desktop.addEventListener?.('change', placeCurrency);
  window.addEventListener('pageshow', placeCurrency, { passive: true });
  window.addEventListener('resize', placeCurrency, { passive: true });
  document.addEventListener('shopify:section:load', init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["joffz-journal-scripts"] && !Shopify.designMode) return;
  try {
    (() => {
  'use strict';

  const pushEvent = (event, detail = {}) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...detail });
  };

  const slugify = (text) => {
    return text
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '') || 'section';
  };

  const ensureUniqueId = (heading, usedIds) => {
    const base = heading.id || slugify(heading.textContent.trim());
    let id = base;
    let index = 2;

    while (usedIds.has(id) || document.getElementById(id)) {
      if (heading.id === id) break;
      id = `${base}-${index}`;
      index += 1;
    }

    usedIds.add(id);
    heading.id = id;
    return id;
  };

  const buildToc = (root) => {
    const readingMain = root.querySelector('.jz-article-main');
    if (!readingMain) return [];

    const headings = Array.from(readingMain.querySelectorAll('h2')).filter((heading) => {
      return heading.textContent.trim().length > 0 && !heading.closest('[data-jz-ignore-toc]');
    });

    const desktopList = root.querySelector('[data-jz-toc]');
    const mobileList = root.querySelector('[data-jz-toc-mobile]');
    const usedIds = new Set();

    const items = headings.map((heading) => {
      const id = ensureUniqueId(heading, usedIds);
      const label = heading.textContent.trim();
      return { heading, id, label };
    });

    const renderList = (list) => {
      if (!list) return;
      list.textContent = '';

      items.forEach(({ id, label }) => {
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${id}`;
        link.textContent = label;
        link.dataset.jzTocLink = id;
        item.appendChild(link);
        list.appendChild(item);
      });

      if (!items.length) {
        list.closest('.jz-toc')?.setAttribute('hidden', '');
      }
    };

    renderList(desktopList);
    renderList(mobileList);

    root.querySelectorAll('[data-jz-toc-link]').forEach((link) => {
      link.addEventListener('click', () => {
        pushEvent('journal_toc_click', {
          article_title: document.querySelector('.jz-article-hero h1')?.textContent.trim() || '',
          section_name: link.textContent.trim()
        });
      });
    });

    return items;
  };

  const setActiveToc = (root, items) => {
    if (!items.length || !('IntersectionObserver' in window)) return;

    const activate = (id) => {
      root.querySelectorAll('[data-jz-toc-link]').forEach((link) => {
        const isActive = link.dataset.jzTocLink === id;
        link.classList.toggle('is-active', isActive);
        if (isActive) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      });
    };

    const observer = new IntersectionObserver((entries) => {
      const visible = entries
        .filter((entry) => entry.isIntersecting)
        .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);

      if (visible.length) activate(visible[0].target.id);
    }, {
      rootMargin: '-18% 0px -68% 0px',
      threshold: [0, 1]
    });

    items.forEach(({ heading }) => observer.observe(heading));
  };

  const initProgress = (root) => {
    const bar = root.querySelector('[data-jz-progress]');
    const zone = root.querySelector('[data-jz-reading-zone]');
    if (!bar || !zone) return;

    let ticking = false;
    const update = () => {
      const start = zone.getBoundingClientRect().top + window.scrollY;
      const end = start + zone.offsetHeight - window.innerHeight;
      const distance = Math.max(1, end - start);
      const progress = Math.min(1, Math.max(0, (window.scrollY - start) / distance));
      bar.style.transform = `scaleX(${progress})`;
      ticking = false;
    };

    const requestUpdate = () => {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    };

    update();
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });
  };

  const initScrollTracking = (root) => {
    const zone = root.querySelector('[data-jz-reading-zone]');
    if (!zone) return;

    const sent = new Set();
    const thresholds = [25, 50, 75, 90];
    const articleTitle = root.querySelector('.jz-article-hero h1')?.textContent.trim() || '';

    const check = () => {
      const start = zone.getBoundingClientRect().top + window.scrollY;
      const end = start + zone.offsetHeight - window.innerHeight;
      const distance = Math.max(1, end - start);
      const percent = Math.max(0, Math.min(100, ((window.scrollY - start) / distance) * 100));

      thresholds.forEach((threshold) => {
        if (percent >= threshold && !sent.has(threshold)) {
          sent.add(threshold);
          pushEvent(`journal_scroll_${threshold}`, {
            article_title: articleTitle,
            scroll_percent: threshold
          });
        }
      });
    };

    window.addEventListener('scroll', check, { passive: true });
    check();
  };

  const initCopyLink = (root) => {
    root.querySelectorAll('[data-jz-copy-link]').forEach((button) => {
      button.addEventListener('click', async () => {
        const original = button.textContent;
        try {
          await navigator.clipboard.writeText(window.location.href);
          button.textContent = 'Link copied';
          pushEvent('journal_share_click', { share_channel: 'copy_link' });
        } catch (error) {
          const input = document.createElement('input');
          input.value = window.location.href;
          document.body.appendChild(input);
          input.select();
          document.execCommand('copy');
          input.remove();
          button.textContent = 'Link copied';
        }
        window.setTimeout(() => { button.textContent = original; }, 1800);
      });
    });
  };

  const initArticle = (root) => {
    const title = root.querySelector('.jz-article-hero h1')?.textContent.trim() || '';
    pushEvent('journal_article_view', { article_title: title });
    const tocItems = buildToc(root);
    setActiveToc(root, tocItems);
    initProgress(root);
    initScrollTracking(root);
    initCopyLink(root);
  };

  const initClickTracking = () => {
    document.addEventListener('click', (event) => {
      const productLink = event.target.closest('[data-jz-product-link]');
      if (productLink) {
        pushEvent('journal_product_click', {
          product_title: productLink.querySelector('h3')?.textContent.trim() || '',
          destination: productLink.href
        });
      }

      const collectionLink = event.target.closest('[data-jz-collection-link]');
      if (collectionLink) {
        pushEvent('journal_collection_click', {
          destination: collectionLink.href
        });
      }

      const relatedLink = event.target.closest('[data-jz-related-article]');
      if (relatedLink) {
        pushEvent('journal_related_article_click', {
          article_title: relatedLink.querySelector('.jz-card__title')?.textContent.trim() || '',
          destination: relatedLink.href
        });
      }

      const shareLink = event.target.closest('.jz-share a');
      if (shareLink) {
        pushEvent('journal_share_click', {
          share_channel: shareLink.getAttribute('aria-label') || shareLink.textContent.trim()
        });
      }
    });

    document.querySelectorAll('.jz-newsletter__form').forEach((form) => {
      form.addEventListener('submit', () => pushEvent('journal_newsletter_submit'));
    });
  };

  const init = () => {
    document.querySelectorAll('[data-jz-article-root]').forEach(initArticle);
    initClickTracking();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
